import { gql } from "@apollo/client";

const CREATE_PLACE = gql`mutation CreatePlace($name: String!, $capacity: Int!){
  createPlace(
    input: { place: { name: $name, capacity: $capacity } }
  ) {
    place {
      uid
      name
      capacity
    }
  }
} `;

const LIST_PLACES = gql`query GetPlaces($first: Int = 100, $offset: Int = 0, $filter: PlaceFilter){
  allPlaces(
    filter: $filter,
    first: $first,
    offset: $offset,
    orderBy: [NAME_ASC]) {
    nodes {
      uid
      name
      capacity
      organizationUid
    }
    totalCount
  }
} `;

const LIST_AVAILABLE_PLACES = gql`query GetAvailablePlaces($day: Day!, $startTime: Time!, $endTime: Time!, $periodUid: UUID!, $first: Int = 100, $offset: Int = 0, $filter: PlaceFilter){
  listAvailablePlaces(
    aDay: $day,
    aPeriodUid: $periodUid,
    e:  $endTime,
    s:  $startTime,
    filter: $filter,
    first: $first,
    offset: $offset) {
    nodes {
      uid
      name
      capacity
      organizationUid
    }
    totalCount
  }
} `;

const DELETE_PLACE = gql`mutation DeletePlace($placeUid: UUID!) {
  deletePlaceByUid(input: { uid: $placeUid }){
    place{
      uid
      name
    }
  }
}
`;

export {
  CREATE_PLACE,
  LIST_PLACES,
  LIST_AVAILABLE_PLACES,
  DELETE_PLACE,
};
